module.exports = __webpack_public_path__ + "img/gsjj.cc129745.png";